






import Vue from 'vue';
import { mapState } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  computed: mapState([
    'fiId',
  ]),
})
export default class LegacyRedirect extends Vue {
	@Prop() destination!:string;

	fiId!:string;

	mounted() {
	  let url: string = 'https://krp-reporting.';

	  if (window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf('.dev.') !== -1) {
	    url += 'dev.';
	  } else if (window.location.href.indexOf('.uat.') !== -1) {
	    url += 'uat.';
	  }

	  url += 'kasasaonline.com/#/';

	  if (this.fiId) {
	    url += `${this.fiId}/`;

	    if (this.destination) {
	      url += this.destination;

	      // Special cases for the endpoints that end in -detail in the legacy app.
	      // Each of those requires a trailing slash.
		  	// We cannot put that in the destination parameter as the router will strip it.
	      if (this.destination.endsWith('-detail')) {
			  url += '//';
		  }
	    }
	  }
	  window.location.replace(url);
	}
}
